var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"indexBox"},[_c('div',{ref:"indexBg",staticClass:"index page"},[_c('div',{ref:"btnBox",staticClass:"btnbox"},[_c('img',{ref:"startBtn",staticClass:"startbtn",attrs:{"src":""},on:{"click":_vm.startClick}})])])])}
var staticRenderFns = []

export { render, staticRenderFns }